import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'lodash';
import { Avatar, Breadcrumb, Button, Col, Input, Modal, Row, Select, Switch, Table, Tabs, Tooltip, message } from 'antd';
import { ApartmentOutlined, DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, ShoppingOutlined } from '@ant-design/icons';
import { SetRoute } from '../scripts/action';
import { CheckPermission } from '../scripts/helpers';
import { Constants, Permissions } from '../scripts/settings';
import API from '../scripts/api';
import Resources from '../scripts/resources';
import PaginationInfo from '../components/PaginationInfo';
import EditBankForm from '../forms/EditBank';

class BankPage extends Component {
    constructor() {
        super();

        this.state = {
            activeTab: 'main',
            mainCats: [],
            mainPagination: {
                total: 0,
                current: 1,
                pageSize: Constants.pageSize,
                size: 'small'
            },
            subCats: [],

        };

        this.formRef = React.createRef();
        this.subRef = React.createRef();

    }

    fetch = (params = {}, subMode) => {
        this.setState({ loading: true });

        params.type = subMode ? 'sub' : 'main';
        params.type = subMode && params.parentId ? '' : params.type;

        API.bank.list(params)
            .then((result) => {

                    this.setState({
                        loading: false,
                        mainCats: result.data,
                        mainPagination: {
                            ...this.state.mainPagination, ...{
                                total: result.data.length
                            }
                        }
                    });

            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    showModal = (category = {}, subMode) => {
        category.subCategory = category.subCategory || this.state.parentId;

        this.setState({ visible: true, selected: category });

        setTimeout(() => {
            this.formRef.current.handleDidMount(category);
        }, 0);
    }

    hideModal = () => {
        this.setState({ visible: false });

        setTimeout(() => {
            this.formRef.current.handleWillUnmount();
        }, 0);
    }



    handleChange = (tab) => {
        if (!this.state.loading)
            this.setState({ activeTab: tab });
    }




    handleMainTableChange = (pagination) => {
        this.setState({
            mainPagination: { ...this.state.mainPagination, ...{ current: pagination.current } }
        });
    }




    handleDelete = (record, subMode) => {
        Modal.confirm({
            title: Resources.confirmDeleteBank,
            okText: Resources.yes,
            okType: 'danger',
            cancelText: Resources.no,
            onOk: () => {
                this.setState({ loading: true });

                API.bank.delete(record)
                    .then((result) => {
                        message.success(result.message);

                        const { mainSearch, parentId, subPagination, subSearch } = this.state;
                        this.fetch({ q: mainSearch });
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    }

    handleSubmit = (values) => {
        const { activeTab, mainSearch, parentId, selected, subPagination, subSearch } = this.state;
        const action = selected.id ? API.bank.update : API.bank.add;

        this.setState({ submitting: true });

        action(values, selected.id)
            .then((result) => {
                message.success(result.message);
                this.setState({ submitting: false });
                this.hideModal();

                if (activeTab === 'main')
                    this.fetch({ q: mainSearch });
                else
                    this.fetch({ page: subPagination.current, parentId: parentId, q: subSearch }, true);
            })
            .catch(() => {
                this.setState({ submitting: false });
            });
    }

    componentDidMount() {
        const { onSetRoute, routeName, parentName } = this.props;

        onSetRoute({ openKey: parentName, selectedKey: routeName });

        this.fetch();
        this.fetch({ page: 1 }, true);
    }

    render() {
        const { activeTab, loading, mainCats, mainPagination, mainSearch, parentId, subCats, submitting, subPagination, visible } = this.state;
        const { permissions } = this.props;
        const mainCategories = mainSearch ? mainCats.filter(o => o.name.indexOf(mainSearch) >= 0) : mainCats;

        const mainColumns = [{
            title: Resources.title,
            dataIndex: 'name'
        }];



        if (permissions.action) {
            mainColumns.push({
                title: Resources.action,
                dataIndex: 'id',
                className: 'col-center',
                width: '120px',
                render: (val, record) => (
                    <Fragment>
                        <Tooltip title={Resources.edit}>
                            <Button type="link" icon={<EditOutlined />} onClick={() => this.showModal(record)} />
                        </Tooltip>
                        <Tooltip title={Resources.delete}>
                            <Button type="link" icon={<DeleteOutlined />} onClick={() => this.handleDelete(record)} />
                        </Tooltip>
                    </Fragment>
                )
            });

        }

        return (
            <Fragment>
                <Breadcrumb>
                    <Breadcrumb.Item>{Resources.banks}</Breadcrumb.Item>
                </Breadcrumb>
                <div className="ant-content">
                    <Tabs activeKey={activeTab} type="card" onTabClick={this.handleChange}>
                        <Tabs.TabPane tab={`${Resources.banks}`} key="main">
                            <Row gutter={24} style={{ marginBottom: 16 }}>
                                {permissions.add && <Col xs={24} md={4}>
                                    <Button type="primary" icon={<PlusOutlined />} onClick={() => this.showModal()} block>{Resources.add}</Button>
                                </Col>}
                            </Row>
                            <Table
                                columns={mainColumns}
                                dataSource={mainCategories}
                                loading={loading}
                                onChange={this.handleMainTableChange}
                                pagination={mainPagination}
                                size="small"
                                rowKey="id"
                                scroll={{ x: 600 }}
                            />
                            {!!mainPagination.total && <PaginationInfo current={mainPagination.current} pageSize={mainPagination.pageSize} total={mainPagination.total} style={{ bottom: 0, right: 0 }} />}
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                <EditBankForm ref={this.formRef} onCancel={this.hideModal} onSubmit={this.handleSubmit} submitting={submitting} visible={visible} />
            </Fragment>
        );
    }
};

export default connect(
    (state) => {
        return {
            permissions: {
                action: CheckPermission(state.app.user, Permissions.category_option),
                add: CheckPermission(state.app.user, Permissions.category_store)
            }
        };
    },
    (dispatch) => {
        return {
            onSetRoute: (data) => dispatch(SetRoute(data))
        };
    }
)(BankPage);